module.exports = __webpack_public_path__ + "static/Titans_Give_2022_001-800x500-6cedd1db8632606eea470b2185720a4f.jpg";